import $ from 'jquery'
import React from 'react'


function Tabs({choices, value, onClick}) {

    return (
        <div className={"tabs-widget"}>
            {choices.map((choice, i) => (
                <div
                    key={i}
                    className={
                        "tab"
                        + (choice===value?" active": "")
                        + (i === 0? " left": i===choices.length-1 ? " right": "")
                    }
                    onClick={(e)=>{ e.preventDefault(); if (onClick) { onClick(choice); }}}
                >
                    {choice}
                </div>
            ))}
        </div>
    );
}

export default Tabs


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/Tabs.js